import type { MenuItem } from '@/types';

/**
 * Quick Start Menu
 */
export const getStartedMenu: MenuItem[] = [
  { label: 'Quick Start with Portal', path: '/getting-started/basic-demo' },
  { label: 'Additional Resources', path: '/getting-started/advanced-demo' },

];

/**
 * Integration Guides Menu
 */
export const intGuideMenu: MenuItem[] = [
  { label: 'Three Phases of Streaming', path: '/integration-guides/three-phases-of-streaming' },
  { label: 'Real-Time Use Cases', path: '/integration-guides/real-time-use-cases' },

];

/**
 * Popular KB Article Menu
 */
export const popularMenu: MenuItem[] = [
  {
    label: 'Encoding and Publishing Bitrates',
    path: '/knowledge-base/faqs/what-bitrates-are-used-for-encoding-and-publishing',
  },
  {
    label: 'Capabilities',
    path: '/knowledge-base/reference/capabilities',
  },
];

/**
 * Recently Added Document Menu
 */
export const recentMenu: MenuItem[] = [
  {
    label: 'Real-Time Use Cases',
    path: '/integration-guides/real-time-use-cases',
  },
  {
    label: 'On Which Cloud Platforms is the Phenix Platform Deployed',
    path: '/knowledge-base/faqs/on-which-cloud-platforms-is-the-phenix-platform-deployed',
  },
];
